/**
 * Downloads a Blob file
 */
export function downloadFile(file: Blob, filename: string): void {
  const url = window.URL.createObjectURL(file);
  const link = document.createElement('a');
  link.setAttribute('style', 'display:none;');
  document.body.appendChild(link);
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
}
